var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSickLeave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 7.5V12.5C34.4891 12.5 36.3968 13.2902 37.8033 14.6967C39.2098 16.1032 40 18.0109 40 20V47.5C40 48.163 39.7366 48.7989 39.2678 49.2678C38.7989 49.7366 38.163 50 37.5 50H2.5C1.83696 50 1.20107 49.7366 0.732234 49.2678C0.263393 48.7989 0 48.163 0 47.5V20C0 18.0109 0.790177 16.1032 2.1967 14.6967C3.60322 13.2902 5.51088 12.5 7.5 12.5V7.5H32.5ZM22.5 22.5H17.5V27.5H12.5V32.5H17.4975L17.5 37.5H22.5L22.4975 32.5H27.5V27.5H22.5V22.5ZM37.5 0V5H2.5V0H37.5Z",
    fill: "#4CBDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSickLeave);
export default __webpack_public_path__ + "static/media/ic_sick_leave.6f217cb479e24a039bc4950d0030a0b8.svg";
export { ForwardRef as ReactComponent };